import React from 'react';

export const StringCell = (item: string) => {
  return <div>{item}</div>;
};
